import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import Link from "next/link";
import React from "react";

interface userMenuProps {
  handleLogout: Function;
  handleMenuClose: Function;
  anchorEl: any;
}
function UserMenu({ handleMenuClose, handleLogout, anchorEl }: userMenuProps) {
  const menuId = "primary-search-account-menu";
  const isMenuOpen = Boolean(anchorEl);
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={() => handleMenuClose()}
    >
      <MenuItem onClick={() => handleMenuClose()}>
        {" "}
        {/* <Link href="/my-orders">My Orders</Link> */}
        <Link href={`/my-orders`}>My Orders</Link>
      </MenuItem>
      <MenuItem onClick={() => handleMenuClose()}>
        {/* <Link href="/my-profile">My Profile</Link> */}
        <Link href={`/my-profile`}>My Profile</Link>
      </MenuItem>
      <MenuItem onClick={() => handleLogout()}>Logout</MenuItem>
    </Menu>
  );
}
export default UserMenu;
